module.exports = "/_next/static/images/contact_3-eeb6739a1e8a4e468f09b26ffbf32f99.png";